<template>
    <!-- The Automatic mode's card, on the same base card as the On Demand
         Data Settings card: title, banded rows, and the action that opens the
         recipient picker. This card is read-only; editing happens in the
         slide-over the button opens. -->
    <report-card title="Automatic Delivery">
        <template #actions>
            <button v-if="canEdit"
                    type="button"
                    class="inline-flex shrink-0 items-center gap-2 rounded-md border border-blue-600 bg-white px-3 py-1.5 text-sm font-normal leading-5 text-blue-600 transition-colors duration-150 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    @click="$emit('edit')">
                <tabler-icon    name="pencil"
                                size-class="h-4 w-4"
                ></tabler-icon>
                Edit Recipients
            </button>
        </template>

        <div :class="rowClass">
            <span class="flex h-6 w-10 shrink-0 items-center justify-center text-gray-500">
                <tabler-icon name="calendar" size-class="h-5 w-5"></tabler-icon>
            </span>
            <span class="text-sm text-gray-900">Sends Monthly</span>
            <info-tip text="Emailed around 2 AM site time on the last day of each month. It lists only expired or nearly expired probes, and is not sent if there are none."></info-tip>
        </div>

        <div :class="rowClass">
            <span class="flex h-6 w-10 shrink-0 items-center justify-center text-gray-500">
                <tabler-icon name="users" size-class="h-5 w-5"></tabler-icon>
            </span>
            <span class="text-sm text-gray-900">{{ recipientLabel }}</span>
            <info-tip text="This list is shared by everyone on this site, and anyone removed from the site is dropped from it. To run the report once for yourself, use On Demand."></info-tip>
        </div>
    </report-card>
</template>

<script>
import TablerIcon from "@/components/elements/TablerIcon.vue";
import InfoTip from "@/components/elements/InfoTip.vue";
import ReportCard, {REPORT_CARD_ROW_CLASS} from "./ReportCard.vue";

export default {
    name: "CalibrationSubscribers",
    components: {InfoTip, ReportCard, TablerIcon},
    emits: ['edit'],
    props: {
        // Saving recipients needs manage_calibration_report, so a user without
        // it sees the summary but not the button that opens the editor.
        canEdit: {
            type: Boolean,
            default: true,
        },
        selectedUsers: {
            type: Array,
            default() {
                return []
            },
        },
    },
    computed: {
        rowClass() {
            return REPORT_CARD_ROW_CLASS
        },
        recipientLabel() {
            const count = Array.isArray(this.selectedUsers) ? this.selectedUsers.length : 0

            if (count === 0) {
                return 'No recipients selected'
            }

            return `${count} ${count === 1 ? 'recipient' : 'recipients'} selected`
        },
    },
}
</script>
